module.exports = __webpack_public_path__ + "images/1340b55d8066a8356aee2a1928c34ca4-IMG_8209.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8209.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8209.jpg
// module chunks = 0